'use client'
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import styles from './ProfileStatsCard.module.css';

interface ProfileStatsCardProps {
    title: string;
    subtitle: string;
    value: number;
    label: string;
}

export const ProfileStatsCard = ({ title, subtitle, value, label }: ProfileStatsCardProps) => {
    const isYearType = label.toLowerCase().includes('ano');

    const data = isYearType
        ? [{ id: 'completed', value: 100 }]
        : [
                { id: 'completed', value: value },
                { id: 'remaining', value: Math.max(0, 100 - value) },
            ];

    const COLORS = isYearType ? ['var(--primary)'] : ['var(--primary)', 'var(--bg-deep)'];

    return (
        <div className={styles.statsCard}>
            <div className={styles.chartContainer}>
                <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                        <Pie
                            data={data}
                            cx="50%"
                            cy="50%"
                            innerRadius="65%"
                            outerRadius="90%"
                            startAngle={90}
                            endAngle={-450}
                            paddingAngle={0}
                            dataKey="value"
                            stroke="none"
                        >
                            {data.map((item, index) => (
                                <Cell key={item.id} fill={COLORS[index]} />
                            ))}
                        </Pie>
                    </PieChart>
                </ResponsiveContainer>
                <div className={styles.centerValue}>
                    <p className={styles.centerNumber}>{value}</p>
                    {!isYearType && <span className={styles.percentSymbol}>%</span>}
                </div>
            </div>
            <div className={styles.cardHeader}>
                <h3 className={styles.cardTitle}>{title}</h3>
                <p className={styles.cardSubtitle}>{subtitle}</p>
            </div>
        </div>
    );
};
